var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcRoles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2924 2.77553C13.4563 1.87276 12.2884 1.37561 10.9993 1.37561C9.70337 1.37561 8.53161 1.86975 7.69931 2.76694C6.85798 3.67401 6.44806 4.90678 6.54431 6.23795C6.73509 8.8642 8.73357 11.0006 10.9993 11.0006C13.2651 11.0006 15.2601 8.86463 15.4539 6.23881C15.5514 4.91967 15.1389 3.68948 14.2924 2.77553Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5623 20.6251H3.43726C3.23929 20.6277 3.04323 20.5861 2.86335 20.5034C2.68347 20.4207 2.5243 20.2989 2.39741 20.1469C2.11812 19.813 2.00554 19.3571 2.0889 18.8961C2.45155 16.8843 3.58335 15.1943 5.36226 14.0079C6.94265 12.9548 8.94456 12.3751 10.9998 12.3751C13.055 12.3751 15.0569 12.9552 16.6373 14.0079C18.4162 15.1939 19.548 16.8838 19.9106 18.8956C19.994 19.3567 19.8814 19.8126 19.6021 20.1465C19.4753 20.2985 19.3161 20.4204 19.1362 20.5032C18.9563 20.586 18.7603 20.6276 18.5623 20.6251Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRoles);
export default __webpack_public_path__ + "static/media/ic-roles.95c7cfe644ec9f01100911e6be93a117.svg";
export { ForwardRef as ReactComponent };